import React from 'react';
import { Tag, Tooltip } from 'antd';
import { CheckCircleFilled, MailOutlined } from '@ant-design/icons';

import { formatDisplayDateTime } from '../../utils/dateDisplay';

/**
 * The email-verification data point, everywhere an account is shown: a
 * green "Verified" tag with the confirmation time one hover away, or an
 * amber "Unverified" tag. Purely presentational — the resend action lives
 * with the caller (the profile page, the admin drawer), because who may
 * resend differs by surface.
 */
export default function VerifiedBadge({ verified, verifiedAt, size = 'default', style }) {
	if (verified) {
		return (
			<Tooltip title={verifiedAt ? `Email confirmed ${formatDisplayDateTime(verifiedAt)}` : 'Email confirmed'}>
				<Tag
					color='success'
					icon={<CheckCircleFilled />}
					style={{ marginInlineEnd: 0, ...(size === 'small' ? { fontSize: 11, lineHeight: '18px', paddingInline: 6 } : {}), ...style }}
					aria-label='Email verified'
				>
					Verified
				</Tag>
			</Tooltip>
		);
	}
	return (
		<Tooltip title='This email address has not been confirmed yet.'>
			<Tag
				color='warning'
				icon={<MailOutlined />}
				style={{ marginInlineEnd: 0, ...(size === 'small' ? { fontSize: 11, lineHeight: '18px', paddingInline: 6 } : {}), ...style }}
				aria-label='Email not verified'
			>
				Unverified
			</Tag>
		</Tooltip>
	);
}
